module.exports = __webpack_public_path__ + "img/news_01.4e014b4c.jpg";